import { useSyncExternalStore } from 'react'

// custom hook that detects network status
function useNetwork() {
  const isOnline = useSyncExternalStore(subscribe, getSnapshot)

  function getSnapshot() {
    return navigator.onLine
  }

  function subscribe(callback: any) {
    window.addEventListener('online', callback)
    window.addEventListener('offline', callback)
    return () => {
      window.removeEventListener('online', callback)
      window.removeEventListener('offline', callback)
    }
  }

  return isOnline
}

export default useNetwork
